interface EmptyStateProps {
  readonly title: string;
  readonly description: string;
  readonly icon?: React.ReactNode;
  readonly action?: {
    readonly label: string;
    readonly onClick: () => void;
  };
}

const ClipboardIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="w-12 h-12 text-ink-faint"
    stroke="currentColor"
    strokeWidth={2}
    fill="none"
  >
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" />
    <line x1="9" y1="14" x2="15" y2="14" />
    <line x1="9" y1="11" x2="15" y2="11" />
    <line x1="12" y1="8" x2="12" y2="8.01" />
  </svg>
);

export function EmptyState({
  title,
  description,
  icon,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      {icon || <ClipboardIcon />}
      <h3 className="mt-4 text-lg font-semibold text-ink">{title}</h3>
      <p className="mt-2 text-sm text-ink-muted max-w-xs text-center">
        {description}
      </p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-6 bg-accent text-white px-6 py-3 rounded-xl font-semibold text-sm hover:opacity-90 transition-opacity"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
